// coloca zero a esquerda
export function isValidDate(date: any): boolean {
  const parsedDate = new Date(date);
  return parsedDate instanceof Date && !isNaN(parsedDate.getTime());
}